import React, { useRef } from "react";
import PropTypes from "prop-types";
import { ModalClosed } from "~misc/icons";

import { Form, Formik } from "formik";
import Select from "~components/Form/components/Select";
import useRouteModal from "../../hooks/useRouteModal";
import useLocal from "~fetchs/useLocal";

const ModalFinalizarVisita = ({ isOpen, onClose, submit, trilha }) => {
  const modalClasses = isOpen ? "fixed inset-0 bg-black bg-opacity-0 z-[99999]" : "hidden";
  const overlayClasses = isOpen ? "fixed inset-0 bg-black opacity-50 z-40" : "hidden";

  const formikRef = useRef();
  const { initial, validation } = useRouteModal();

  const { optionLocais, onChangeLocal, localSelect } = useLocal({ formikRef, trilha });

  return (
    <Formik
      innerRef={formikRef}
      initialValues={initial}
      validationSchema={validation}
      onSubmit={(values) => {
        submit(values);
        onClose();
      }}
    >
      {({ errors, touched, setFieldValue }) => (
        <Form className={modalClasses}>
          <div className="fixed inset-0 flex items-center justify-center z-50">
            <div className="bg-white min-w-[680px] px-14 py-14 rounded-[20px] shadow-lg z-50  relative">
              <div className="flex justify-end">
                <button
                  type="button"
                  onClick={onClose}
                  className="text-gray-500 p-4 rounded-tr-[20px] hover:text-gray-700 bg-quinaria absolute top-0 right-0"
                  data-testid="modal-close-button"
                  aria-label="Fechar modal"
                >
                  <ModalClosed />
                </button>
              </div>
              <h3 className="text-3xl max-w-[310px] text-center mx-auto font-bold mb-4">
                Informe o <b className="font-bold text-terciaria">local</b> onde as informações foram coletadas:
              </h3>
              <Select
                name="localId"
                label=""
                placeholder="Digite para Buscar o Local"
                options={optionLocais}
                noOptionsMessage="Local não encontrado"
                onChange={onChangeLocal}
                errors={errors.localId}
                touched={touched.localId}
                setFieldValue={setFieldValue}
                {...localSelect}
              />
              <p className="text-3xl max-w-[310px] text-center mx-auto font-bold">Finalizar a visita?</p>
              <div className="flex justify-center gap-x-4 mt-4">
                <button className="px-6 py-4 rounded-md bg-secundaria font-bold" type="submit">
                  Sim
                </button>
                <button
                  className="px-6 py-4 rounded-md bg-quinaria font-bold text-white"
                  type="button"
                  onClick={onClose}
                >
                  Não
                </button>
              </div>
            </div>
            <div className={overlayClasses} onClick={onClose} data-testid="modal-overlay"></div>
          </div>
        </Form>
      )}
    </Formik>
  );
};

ModalFinalizarVisita.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  trilha: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
};

export default ModalFinalizarVisita;
